import React from 'react'
import {Calendar as BigCalendar, momentLocalizer} from 'react-big-calendar'
import moment from 'moment'
import Toolbar from './Toolbar'

import './index.css'

const localizer = momentLocalizer(moment)

const Calendar = ({
  events = [],
  components = {},
  messages = {},
  ...rest
}) => (
  <div style={{
    position: 'absolute',
    height: '100%',
    width: '100%',
    margin: '-15px',
  }}>
    <BigCalendar
      localizer={localizer}
      events={events}
      scrollToTime={moment().set({hour: 6, minute: 0, second: 0}).toDate()}
      components={{
        toolbar: Toolbar,
        ...components
      }}
      messages={{
        today: 'I dag',
        month: 'Måned',
        week: 'Uke',
        day: 'Dag',
        ...messages
      }}
      {...rest}
    />
  </div>
)

Calendar.localizer = localizer

export default Calendar
